import FileDownloadApi from './FileDownloadApi';
import HttpService from './HttpService';

const ValidationApi = HttpService('/api/validation/');
const doGet = (url) => ValidationApi.get(url);

export default {
  getVoyageValidationReport(voyageReportId) {
    const apiAction = 'GetVoyageValidationReport';
    const queryString = `id=${voyageReportId}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  getVoyageValidationReportAsExcelFile(voyageReportId) {
    const fullUrl = `validation/GetValidationReportAsExcelFile?voyageReportId=${voyageReportId}`;
    return FileDownloadApi().get(fullUrl);
  },
};
